import classNames from 'classnames';
import React from 'react';
const Button = (props) => {
    const handleClick = (e) => {
        if (props.usesDefault != undefined && !props.usesDefault && props.onClick) {
            e.preventDefault();
        }
        props.onClick && props.onClick.call(this, e);
    };
    const handleKeyDown = (e) => {
        if (props.usesDefault != undefined && !props.usesDefault && props.onKeyDown) {
            e.preventDefault();
        }
        props.onKeyDown && props.onKeyDown.call(this, e);
    };
    return (React.createElement("button", { ref: props.reference, onClick: handleClick, onFocus: props === null || props === void 0 ? void 0 : props.onFocus, onKeyDown: handleKeyDown, disabled: props.disabled, className: classNames('button', props.cls, props.className, { loading: props.isLoading }, { full: props.fullWidth }, { inverted: props.inverted }), type: props.type, "aria-label": props.ariaLabel, "aria-expanded": props.ariaExpanded, "aria-haspopup": props.ariaHaspopup, "aria-controls": props.ariaControls, "aria-hidden": props.ariaHidden, "aria-pressed": props.ariaPressed, tabIndex: props.customTabIndex ? props.customTabIndex : undefined, id: props.id, "data-pressed": props.pressed }, props.customChildren ? props.children : React.createElement("span", null, props.children)));
};
Button.defaultProps = {
    cls: ['button--primary'],
    className: '',
};
export default Button;
